import VideoCallIcon from '@mui/icons-material/VideoCall';
import { useTheme } from '@mui/material';
import { tertiaryHoverSx } from '../../styles/Global.style';

export const AddVideo = () => {
  const theme = useTheme();

  return <VideoCallIcon fontSize="medium" sx={tertiaryHoverSx(theme)} />;
};
